import React from 'react';
import QuestionItem from './question_item';

const QuestionList = ({ questions, setQuestions }) => {
  const update = (idx, data) =>
    setQuestions((qs) => qs.map((q, i) => (i === idx ? { ...q, ...data } : q)));

  const remove = (idx) => setQuestions((qs) => qs.filter((_, i) => i !== idx));

  return (
    <>
      {questions.map((q, i) => (
        <QuestionItem
          key={i}
          idx={i}
          question={q}
          onChange={(data) => update(i, data)}
          onRemove={() => remove(i)}
        />
      ))}
    </>
  );
};

export default QuestionList;
